module.exports = __webpack_public_path__ + "static/media/background.c2680ce4.svg";